import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CamionEAD;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un CamionEAD
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdConfigAutotransporte : validation.required,
        IdTipoPermiso: validation.required,
        Nombre: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class CamionEADFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const Sucursal = getField(selectores.Sucursal);
        const CpSatTipoPermisoSelector = getField(selectores.CpSatTipoPermisoSelector);
        const CpSatConfigAutotransporte = getField(selectores.CpSatConfigAutotransporteSelector);

        return (
            <div>
                <kea.Title titulo="CamionEAD" onRegresar={() => history.go("/catalogos/CamionesEAD")} />
                {kea.autogrid(3, [
                    <Text field="Nombre" label="Nombre:" />,
                    <Sucursal field="IdSucursal" label="Sucursal:" />,
                    <Text field="Aseguradora" label="Nombre de la aseguradora" />,
                    <Text field="NumeroPoliza" label="Número de la poliza del seguro" />,
                    <CpSatTipoPermisoSelector field="IdTipoPermiso" label="Tipo Permiso Sat" />,
                    <Text field="PermisoSCT" label="Número de Permiso SCT" />,
                    <CpSatConfigAutotransporte field="IdConfigAutotransporte" label="Tipo de autotransporte" />,

                    <Text field="Placa" label="Placa:" />,

                    <Text field="Año" label="Año del modelo:" />,
                    <Text field="Peso" label="Peso del camion:" />,

                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const CamionEADForm = componentToRx(CamionEADFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/camionesEAD/edit/form.tsx